import {useApi} from "../ApiSession";
import React, {useEffect, useState} from "react";
import {formatDate} from "../utils";
import Link from "../widgets/Link";

export const VisitNotes = ({roundNote, observation_type_id, healthOverviewDispatch}) => {

    const api = useApi()

    const [noteText, setNoteText] = useState('')

    const [needsSave, setNeedsSave] = useState(false)

    useEffect(() => {
        if (roundNote && roundNote.note) {
            setNoteText(roundNote.note.notes)
        }
    }, [])

    const doSave = () =>
        api.saveNotes(noteText, observation_type_id, roundNote.round.id).then(observation_round_note_id => {
            healthOverviewDispatch({
                name: "updateObservationNote",
                observation_type_id,
                observation_round_note: {
                    id: observation_round_note_id,
                    round_id: roundNote.round.id,
                    observation_type_id,
                    notes: noteText
                }
            })
            setNeedsSave(false)
        })

    return <tr key={`note-${roundNote.round.id}-${observation_type_id}`}>
        <td>
            <div>Notes {roundNote.round.visit_label}</div>
            <div>(visite du {roundNote.round.visit_date})</div>
            {needsSave && <div><Link onClick={doSave} caption={"sauvegarder"}/></div>}
        </td>
        <td>
            <textarea
                rows={2}
                className={
                    "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                }
                value={noteText}
                onChange={e => {
                    setNoteText(e.target.value)
                    setNeedsSave(true)
                }}
            />
        </td>
    </tr>
}